<template>
    <el-row class="ipblacklist container_self table_parent">
        <h3>IP 列表</h3>
        <el-row class="search_parent">
            <el-form :inline="true" :model="queryParams" size="mini" class="demo-form-inline queryForm">
                <el-form-item label="域名">
                    <el-input v-model="queryParams.domain" placeholder="请输要查询的域名" clearable></el-input>
                </el-form-item>
                <el-form-item label="开始时间">
                    <el-date-picker
                        v-model="queryParams.startDate"
                        type="date"
                        value-format="yyyy-MM-dd"
                        clearable
                        :picker-options="pickerOptions"
                        placeholder="选择开始时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="结束时间">
                    <el-date-picker
                        v-model="queryParams.endDate"
                        type="date"
                        value-format="yyyy-MM-dd"
                        clearable
                        :picker-options="pickerOptions"
                        placeholder="选择结束时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSubmit">查询</el-button>
                </el-form-item>
                <el-form-item style="float:right">
                    <el-button type="danger"  size="mini" @click="setOtherIp">设置其他来源ip</el-button>
                </el-form-item>
            </el-form>
        </el-row>
        <el-row style="margin-bottom:10px"><el-button type="danger"  size="mini" @click="setMoreIp">批量拉黑ip</el-button></el-row>
        <el-table :data="tableData"  style="width: 100%"  v-loading="loading" element-loading-text="查询中，请稍后"
            ref="multipleTable" tooltip-effect="dark" @selection-change="handleSelectionChange"
        >
        <el-table-column type="selection"  width="55"></el-table-column>
           <el-table-column prop="count" label="访问次数" align="center" width="80"></el-table-column>
           <el-table-column label="IP地址" align="center">
                <template slot-scope="scope">
                    <el-tooltip content="点击查看此ip对应的域名" placement="top" effect="light">
                        <p style="cursor:pointer;margin:0;width:220px;display: inline-block;" @click="checkDomain(scope.row.ip)">{{scope.row.ip}} <span v-if="scope.row.isBlack" class="mingdan heimingdan">黑</span> <span v-if="scope.row.isWhite" class="mingdan baimingdan">白</span></p>
                    </el-tooltip>
                </template>
           </el-table-column>
           <el-table-column label="操作" align="center" width="200">
                <template slot-scope="scope">
                    <el-button type="danger" size="mini" @click="setItem(scope.row)">设置</el-button>
                </template>
           </el-table-column>
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[50, 100, 200, 500,1000]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>


        <el-dialog title="ip 设置" :visible.sync="dialogFormVisible">
            <el-form :model="setBlackList" class="demo-ruleForm" size="mini">
                <el-form-item label="IP 地址" :label-width="formLabelWidth">
                    <el-input v-model="setBlackList.ip" autocomplete="off" :disabled="isOwner"></el-input>
                </el-form-item>
                <el-form-item label="设置" :label-width="formLabelWidth">
                   <el-select v-model="setBlackList.action" placeholder="请选相关设置" @change="typeChgange" >
                        <el-option :value="1" label="添加黑名单"></el-option>
                        <el-option :value="2" label="添加白名单"></el-option>
                   </el-select>
                </el-form-item>
                <el-form-item label="问题描述" :label-width="formLabelWidth" v-if="setUrl==='/api/ip_fraud_rate/add_ipblack'">
                    <!-- <el-input v-model="setBlackList.description" autocomplete="off"></el-input> -->
                    <el-select v-model="setBlackList.description">
                        <el-option value="IP集中" label="IP集中"></el-option>
                        <el-option value="Cloudflare反馈的IP集中" label="Cloudflare反馈的IP集中"></el-option>
                        <el-option value="其他原因" label="其他原因"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="问题描述" :label-width="formLabelWidth" v-else>
                    <el-input v-model="setBlackList.description" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="IP设置原因" :label-width="formLabelWidth">
                    <el-input v-model="setBlackList.source" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="updateIpStatus">确 定</el-button>
            </div>
        </el-dialog>


        <el-dialog title="批量拉黑 ip" :visible.sync="dialogFormVisibleMore">
            <el-form :model="setBlackList" class="demo-ruleForm" size="mini">
                <el-form-item label="问题描述" :label-width="formLabelWidth">
                    <!-- <el-input v-model="setBlackList.description" autocomplete="off"></el-input> -->
                    <el-select v-model="moreIpForm.description">
                        <el-option value="IP集中" label="IP集中"></el-option>
                        <el-option value="Cloudflare反馈的IP集中" label="Cloudflare反馈的IP集中"></el-option>
                        <el-option value="其他原因" label="其他原因"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="IP设置原因" :label-width="formLabelWidth">
                    <el-input v-model="moreIpForm.source" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisibleMore = false">取 消</el-button>
                <el-button type="primary" @click="updateMorIp">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog :title="'ip： '+checkedIp+' 访问的域名列表'" :visible.sync="domainVisible" width="50%">
            <el-row>共 {{totalDomain}} 条</el-row>
            <el-table :data="iptoDomainList">
                <el-table-column label="域名" prop="domain" align="center"></el-table-column>
                <el-table-column label="访问次数" prop="total" align="center"></el-table-column>
            </el-table>
        </el-dialog>
    </el-row>
</template>

<script>
    import {axiosGet,axiosPost} from '@/assets/ajaxFn'
    import {getPre15date} from '@/assets/dateUtils'
    export default {
        data(){
            return{
                dialogFormVisibleMore:false,
                loading:false,
                ipList:[],
                tableData:[],
                currentPage:1,
                pageSize:50,
                queryParams:{
                    domain:"",
                    endDate:this.getPreDate(new Date(),1),
                    startDate: this.getPreDate(new Date(),1)
                },
                setBlackList:{
                    action:1,
                    description:"",
                    ip:"",
                    source: "",
                },
                total:0,
                dialogFormVisible:false,
                formLabelWidth:"120px",
                domainVisible:false,
                iptoDomainList:[],
                checkedIp:"",
                totalDomain:0,
                pickerOptions: {
                    disabledDate(time) {
                       // 禁用今天及之后的日期
                        return time.getTime() >= new Date(new Date().setHours(0, 0, 0, 0)).getTime();
                    }
                },
                isOwner:true,
                setUrl:'/api/ip_fraud_rate/add_ipblack',
                multipleSelection: [],
                moreIpForm:{
                    "action": 1,
                    "description": "IP集中",
                    "ips": [],
                    "source": ""
                },
                total:0
            }
        },
        methods: {
            fetchData(page = 1) {  
                this.currentPage = page;  
                // 计算并更新表格数据  
                this.tableData = this.ipList.slice((page - 1) * this.pageSize, page * this.pageSize);  
            }, 
            setMoreIp(){
                if(!this.multipleSelection.length){
                    this.$message({message:'请至少选择一个IP',type:'error'});
                    return false;
                }
                this.dialogFormVisibleMore=true;
            },
            updateMorIp(){
                let ipList=[];
                for(var m=0;m<this.multipleSelection.length;m++){
                    ipList.push(this.multipleSelection[m].ip);
                }
                let params={
                    action:1,
                    description:this.moreIpForm.description,
                    source:this.moreIpForm.source,
                    ips:ipList
                }
                axiosPost('/api/ip_fraud_rate/add_ip_black_batch',params,"JSON").then(res=>{
                    if(res.code==0){
                        this.$message({message:'批量设置成功',type:'success'});
                        this.dialogFormVisibleMore=false;
                        this.getList(this.queryParams);
                    }
                })
            },
            handleSelectionChange(val){
                this.multipleSelection = val;
            },
            getPreDate(date,nums){
                let currentDate = new Date(date);
                currentDate.setDate(currentDate.getDate() - nums);
                let endDate = currentDate.toISOString().slice(0, 10);
                return endDate;
            },
            setOtherIp(){
                this.setBlackList={
                    action:1,
                    description:"",
                    ip:"",
                    source: "",
                }
                this.isOwner=false;
                this.dialogFormVisible=true;
            },
            typeChgange(val){
                if(val==1){
                    this.setUrl='/api/ip_fraud_rate/add_ipblack';
                }else{
                    this.setUrl='/api/ip_fraud_rate/add_ip_white';
                }
            },
           async getList(params){
                this.loading=true;
                let blackListArray=[],ipInitArray=[],whiteListArray=[];
              await axiosGet("/api/ip_fraud_rate/ip_count",params).then(res=>{
                    if(res.code==0){
                        this.total=res.data.length;
                        ipInitArray=res.data;
                    }else{
                        this.loading=false;
                    }
                });
                await axiosGet('/api/ip_fraud_rate/ipblack_list',{currentPage:1,pageSize:10000}).then(res=>{
                    if(res.code==0){
                        blackListArray=res.data.records;
                    }
                })
                await axiosGet('/api/ip_fraud_rate/ip_white_list',{currentPage:1,pageSize:10000}).then(res=>{
                    if(res.code==0){
                        whiteListArray=res.data.records;
                    }
                })
                for(var a=0;a<ipInitArray.length;a++){
                    for(var b=0;b<blackListArray.length;b++){
                        if((ipInitArray[a].ip==blackListArray[b].ip)&&!blackListArray[b].disabled){
                            ipInitArray[a].isBlack=true;
                        }
                    }
                }
                for(var a=0;a<ipInitArray.length;a++){
                    for(var b=0;b<whiteListArray.length;b++){
                        if((ipInitArray[a].ip==whiteListArray[b].ip)&&!whiteListArray[b].disabled){
                            ipInitArray[a].isWhite=true;
                        }
                    }
                }
                this.ipList=ipInitArray;
                this.fetchData(1);
                this.loading=false;
            },
            onSubmit(){
                this.getList(this.queryParams);
            },
            handleSizeChange(val){//下拉翻页
                this.pageSize=val;
                this.fetchData(this.currentPage); 
                // this.getList(this.queryParams);
            },
            handleCurrentChange(val){//页码翻页
                this.currentPage=val;
                // this.getList(this.queryParams);
                this.fetchData(val); 
            },
            setItem(item){
                this.isOwner=true;
                this.setBlackList.ip=item.ip;
                this.dialogFormVisible=true;
                this.setUrl="/api/ip_fraud_rate/add_ipblack";
            },
            updateIpStatus(){
                if(!this.setBlackList.action||!this.setBlackList.description||!this.setBlackList.source){
                    this.$message({message:"所有项均不能为空，请仔细填写",type:"error"}); 
                    return false;
                }
                let params={
                    action:1,
                    description:this.setBlackList.description||"",
                    ip:this.setBlackList.ip,
                    source: this.setBlackList.source||"",
                }
                axiosPost(this.setUrl,params,"JSON").then(res=>{
                    if(res.code==0){
                        this.getList(this.queryParams);
                        this.$message({type:'success',message:'ip 状态更新成功'});
                        this.dialogFormVisible=false;
                    }else{
                        this.$message({message:res.message,type:"error"});
                        this.dialogFormVisible=false;
                    }
                })
            },
            checkDomain(ip){
                this.loading=true;
                axiosGet('/api/ip_fraud_rate/domain_count',{ip:ip,startDate:this.queryParams.startDate,endDate:this.queryParams.endDate}).then(res=>{
                    if(res.code==0){
                        this.iptoDomainList=res.data;
                        this.checkedIp=ip;
                        this.totalDomain=res.data.length;
                        this.domainVisible=true;
                        this.loading=false;
                    }else{
                        this.loading=false;
                    }
                })
                
            }
        },
        mounted() {
            this.getList(this.queryParams);
        },
    }
</script>

<style scoped>
    .queryForm{
        width: 80%;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .mingdan{
        display: inline-block;
        width:20px;
        height:20px;
        font-size:12px;
        margin-left: 10px;
    }
    .heimingdan{
        background-color: black;
        color:#fff;
    }
    .baimingdan{
        background-color: white;
        color:#000;
    }
</style>


// WEBPACK FOOTER //
// src/components/view/IpManager/ipCount.vue